import React from 'react'
// Removed undo/redo buttons
import { TitleDisplay } from './title-display'
import { TitleForm } from './title-form'


import { ExportButton } from './export-button'
import { usePodcastEditor } from '../../context/use-podcast-editor'

export const TopBar: React.FC = () => {
  const { editingTitle } = usePodcastEditor()
  return (
    <header className="h-12 rounded-lg border border-black/10 bg-white flex items-center justify-between px-3 mb-4">
      <div className="flex items-center gap-2">
        <div className="ml-2">
          {!editingTitle ? <TitleDisplay /> : <TitleForm />}
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="hidden lg:block">
          <ExportButton />
        </div>
      </div>
    </header>
  )
}
